import GoogleClass, * as GoogleModule from './../../node_modules/ol/source/Google.js';

class Google extends GoogleClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in GoogleModule) {
    if (key !== "default") {
        Google[key] = GoogleModule[key];
    }
}

export default Google;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/Google.js';